
        var result = require("!!../../../../node_modules/css-loader/index.js!./deposit.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/administration/deposit/deposit.component.css
// module id = 2480
// module chunks = 1